import { cloudApi } from './http.js'

export function inspectPastedText(tenantId, projectId, body) {
  return cloudApi.post(`/api/tenants/${encodeURIComponent(tenantId)}/projects/${encodeURIComponent(projectId)}/pasted-text/inspect`, body, { timeoutMs: 10000 })
}
